import React, { useState, useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';

import { Helmet } from 'react-helmet-async';

const SEOMetaTag = memo(() => {
  const [path, setPath] = useState(null);
  const [tag, setTag] = useState(null);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (!pathname || path === pathname) return;

    let tag = getTag(pathname);
    setTag(tag);
    setPath(pathname);

    return () => {};
  }, [pathname, path]);

  return (
    <Helmet>
      <title>{tag?.title || '우노스'}</title>

      <meta
        name='description'
        content={tag?.description || '간편한 결제솔루션, 우노스를 만나보세요.'}
      />
      <meta
        name='keywords'
        content={tag?.keywords || '우노스, 우노스페이, 키오스크, 포스'}
      />

      <meta property='og:type' content='website' />
      <meta property='og:title' content={tag?.title || '우노스'} />
      <meta property='og:site_name' content={tag?.siteName || '우노스'} />
      <meta
        property='og:description'
        content={tag?.description || '간편한 결제솔루션, 우노스를 만나보세요.'}
      />
      <meta
        property='og:image'
        content={'https://unospay.com/imgs/logo192.png'}
      />
      <meta
        property='og:url'
        content={`https://unospay.com${pathname === '/' ? '' : pathname}`}
      />

      <meta name='twitter:title' content={tag?.title || '우노스'} />
      <meta
        name='twitter:description'
        content={tag?.description || '간편한 결제솔루션, 우노스를 만나보세요.'}
      />
      <meta
        name='twitter:image'
        content={tag?.imgsrc || 'https://unospay.com/imgs/logo192.png'}
      />
    </Helmet>
  );
});

export default SEOMetaTag;

function getTag(pathname) {
  let tag = {
    title: '우노스',
    description: '간편한 결제솔루션, 우노스를 만나보세요.',
    siteName: '우노스',
  };

  if (pathname === '/') {
    tag.description = '포스 키오스크를 한 번에';
    tag.siteName = '메인';
  } //
  else if (pathname === '/solution/kiosk') {
    tag = {
      title: '결제부터 다양한 기능까지, 우노스 키오스크',
      description: '포스 키오스크를 한 번에',
      siteName: '우노스솔루션 - 포스',
    };
  } //
  else if (pathname === '/solution/pos') {
    tag = {
      title: '기본에 충실한, 실시간 키오스크 연동 포스',
      description: '기본에 충실한, 실시간 키오스크 연동 포스',
      siteName: '우노스솔루션 - 포스',
    };
  } //
  else if (pathname === '/solution/ukiki') {
    tag = {
      title: '적립, 모바일주문, 고객관리를 한번에',
      description: '적립, 모바일주문, 고객관리를 한번에',
      siteName: '우노스솔루션 - 우키키',
    };
  } //
  else if (pathname === '/solution/management') {
    tag = {
      title: '재고관리부터 매출관리까지 실시간으로',
      description: '재고관리부터 매출관리까지 실시간으로',
      siteName: '우노스솔루션 - 매장관리',
    };
  } //
  else if (pathname.includes('/hardware/kiosk')) {
    tag = {
      title: '다양한 설치형태와 모델, 한번에 비교하기',
      description: '다양한 설치형태와 모델, 한번에 비교하기',
      siteName: '제품소개 - 키오스크',
    };
  } //
  else if (pathname.includes('/hardware/pos')) {
    tag = {
      title: '실시간 키오스크 연동이 가능한 우노스 포스',
      description: '실시간 키오스크 연동이 가능한 우노스 포스',
      siteName: '제품소개 - 포스',
    };
  } //
  else if (pathname === '/support/faq') {
    tag = {
      title: '우노스',
      description: '고객지원 FAQ',
      siteName: '고객지원 - FAQ',
    };
  } //
  else if (pathname === '/support/archive') {
    tag = {
      title: '우노스',
      description: '고객지원 자료실',
      siteName: '고객지원 - 자료실',
    };
  } //
  else if (pathname.includes('/notice/news')) {
    tag = {
      title: '우노스',
      description: '우노스 공지사항',
      siteName: '공지사항 - 우노스 소식',
    };
  } //
  else if (pathname.includes('/notice/update')) {
    tag = {
      title: '우노스',
      description: '우노스 업데이트',
      siteName: '공지사항 - 업데이트',
    };
  }

  return tag;
}
